import { call, takeEvery, put, all } from 'redux-saga/effects';
import authService from '../../../../authService';
import { IOrganisationResponse } from '../../../onboarding/onboardingModels';
import { ISubscriptionBundleResponse, IUserBundleResponse } from '../../../onboarding/PartnerManagement/SKULIst/SKUModels';
import { watchActivitySaga, watchUserDisplayNamesSaga, watchFilterOptionsUserDisplayNamesSaga } from '../../../activity/Redux/activitySaga';
import {
  fetchBundleList,
  fetchBundleListFailed,
  fetchBundleListSuccess,
  fetchOrganisationList,
  fetchOrganisationListFailed,
  fetchOrganisationListSuccess,
  fetchUserList,
  fetchUserListFailed,
  fetchUserListSuccess
} from './globalShared';

let callAPI = async ({ url, method }: { url: string; method: string }) => {
  const res: Response = await authService.authFetch(url, {method: method});
  if (res.ok) {
    return await res.json();
  } else {
    throw Error(res.statusText);
  }
};

export function* fetchOrganisationDataSaga() {
  try {
    const fetchOnPremParam = authService.OFFERING === 'LCBS' ? '?fetchOnPrem=true' : '';
    let result: IOrganisationResponse = yield call(() =>
      callAPI({
        url:
          authService.BASE_URL +
          '/api/RootOrganisations/' +
          authService.OFFERING +
          fetchOnPremParam,
        method: 'GET'
      })
    );

    yield put(fetchOrganisationListSuccess(result.resources));
  } catch (e) {
    yield put(fetchOrganisationListFailed());
  }
}

export function* fetchBundleListSaga() {
  try {
    let result: ISubscriptionBundleResponse = yield call(() =>
      callAPI({
        url: `${authService.BASE_URL}/api/v1/subscriptions/bundles`,
        method: 'GET'
      })
    );

    yield put(fetchBundleListSuccess(result.resources));
  } catch (e) {
    yield put(fetchBundleListFailed());
  }
}

export function* fetchUserListSaga() {
  try {
    let result: IUserBundleResponse = yield call(() =>
      callAPI({
        url: `${authService.BASE_URL}/api/v1/users/me`,
        method: 'GET'
      })
    );
    yield put(fetchUserListSuccess(result));
  } catch (e) {
    yield put(fetchUserListFailed());
  }
}

export function* updatedUserLastActiveTimeSaga() {
  try {
    let result: IUserBundleResponse = yield call(() =>
      callAPI({
        url: `${authService.BASE_URL}/api/v1/users/last-active/me`,
        method: 'PATCH'
      })
    );
    yield put(fetchUserListSuccess(result));
  } catch (e) {
    yield put(fetchUserListFailed());
  }
}

function* watchFetchOrganisationLit() {
  yield takeEvery(fetchOrganisationList, fetchOrganisationDataSaga);
}

function* watchFetchBundleList() {
  yield takeEvery(fetchBundleList, fetchBundleListSaga);
}

function* watchUserBundleList() {
  yield takeEvery(fetchUserList,  fetchUserListSaga);
}

function* watchUserLanstActiveTimeSagaList() {
  yield takeEvery(fetchUserList, updatedUserLastActiveTimeSaga)
}

export default function* sharedSaga() {
  yield all([watchFetchOrganisationLit(), watchFetchBundleList(), watchUserBundleList(), watchUserLanstActiveTimeSagaList(), watchActivitySaga(), watchUserDisplayNamesSaga(), watchFilterOptionsUserDisplayNamesSaga()]);
}
